<template>
  <el-row style="width: 100%;margin-top: 20px;">
    <el-row style="width: 100%;height: 70px;">
      <el-row class="news-logo" />
    </el-row>
    <el-row style="width: 94%;margin-left: 3%;margin-top: 10px;">
      <el-row v-if="content.length > 0" style="width: 100%;">
        <el-row v-for="(item, i) in content" :key="i"  style="width: 100%;margin-bottom: 20px;">
          <el-row style="width: 100%;height: 232px;text-align: left;background-color: #eaf4f7;">
            <el-image :src="getImageUrl(item.newsCover)" class="img-class" fit="cover" @click.native="changeRoute('/news', item.newsType, item.id)"></el-image>
            <el-row style="width: 98%;margin-left: 1%;height: 50px;margin-top: 10px;display: flex;">
              <el-row class="text-class" @click.native="changeRoute('/news', item.id)">
                {{item.titleName}}
              </el-row>
              <el-row style="width: 30%;font-size: 14px;text-align: right;color: #000;">
                {{item.createTime}}
              </el-row>
            </el-row>
          </el-row>
        </el-row>
      </el-row>
      <el-row v-else style="width: 100%;height: 380px;display: flex;align-items: center;justify-content: center;font-size: 32px;color: #00bf86">
        敬 请 期 待
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import axios from 'axios'
export default {
  name: 'News',
  data() {
    return {
      title: [{id: '1', name: '公司新闻'}, {id: '2', name: '行业动态'}],
      content: [],
      // newsList: [{id: '11', name: '2022年春节放假通知 ', img: require('../../assets/img/news/news4.png'), time: '2022-01-20'}],
      newsList: [],
      infoList: [],
      selItem: 0
    }
  },
  created() {
    this.$api.newsManage.getHomeNewsInfo({page: 1, rows: 4, newsType: 0}).then(res => {
      if (res.code !== 500) {
        this.content = res.data.rows
      }
    })
  },
  methods: {
    getImageUrl(id) {
      return '/myApi/newsInfo/getImageById?id=' + id
    },
    changeRoute(path, type, id) {
      const page = type === 0? '71': '72'
      this.$router.push({path: path, query: {page: page, id: id}})
    }
  }
}
</script>

<style scoped>
  .news-logo {
    background: url("../../assets/news.png") no-repeat;
    background-size: 100% 100%;
    width: 70%;
    margin-left: 15%;
    height: 60px;
  }
  .title-class {
    color: #000000;
  }
  .title-class:hover {
    color: #00bf86;
  }
  .title-click-class {
    color: #00bf86;
    border-bottom: 2px solid #00bf86;
  }
  .text-class {
    width: 70%;
    text-align: left;
    color: #000000;
    cursor: pointer;
    white-space:nowrap;
    text-overflow:ellipsis;
    overflow: hidden;
  }
  .text-class:hover {
    color: #00bf86;
  }
  .img-class {
    width: calc(100% - 4px);
    margin-left: 2px;
    margin-top: 2px;
    height: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/News.vue